var map = {
	"./slider1.jpeg": 849,
	"./slider10.jpeg": 847,
	"./slider11.jpeg": 27,
	"./slider12.jpeg": 22,
	"./slider13.jpeg": 426,
	"./slider14.jpeg": 507,
	"./slider15.jpeg": 137,
	"./slider16.jpeg": 101,
	"./slider17.jpeg": 447,
	"./slider18.jpeg": 70,
	"./slider2.jpeg": 523,
	"./slider3.jpeg": 520,
	"./slider4.jpeg": 396,
	"./slider5.jpeg": 752,
	"./slider6.jpeg": 711,
	"./slider7.jpeg": 690,
	"./slider8.jpeg": 773,
	"./slider9.jpeg": 247
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 683;